export default {"src":"/_next/static/media/shopping_bag.1004112c.svg","height":24,"width":24};